import React from "react";
import { process } from "../mock";

const Process = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-4 border border-yellow-200">
            Onze werkwijze
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 text-balance">
            In 5 duidelijke stappen naar een strak resultaat.
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            Geen verrassingen, wel een vakman die u van begin tot eind ontzorgt.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {process.map((step, idx) => (
            <div
              key={step.step}
              className="relative rounded-2xl border border-slate-200 bg-white p-6 hover-lift"
            >
              <div className="flex items-baseline justify-between mb-4">
                <div className="text-3xl font-extrabold text-yellow-400">{step.step}</div>
                {idx < process.length - 1 && (
                  <div className="hidden lg:block w-8 h-px bg-slate-200" />
                )}
              </div>
              <h3 className="font-bold text-slate-900 mb-2">{step.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
